<template>
	<transition>
		<div class="index" :class="{ show: is, hidden: is == false }">
			<left class="left"></left>
			<el-container class="right" @click="is = false">
				<el-header width="100%" height="sumMessage65px">
					<navcon :sumMessage="sumMessage" :baoxiuMessage="baoxiuMessage" :jiazhengMessage="jiazhengMessage"
						@left="show"></navcon>
				</el-header>
				<el-container class="main-con">
					<el-aside width="60px">
						<leftnav></leftnav>
					</el-aside>
					<el-main>
						<router-view></router-view>
					</el-main>
				</el-container>
			</el-container>
		</div>
	</transition>
</template>
<script>
// 导入组件
import navcon from "../components/navcon.vue";
import leftnav from "../components/leftnav.vue";
import left from "../components/left.vue";

export default {
	name: "index",
	data() {
		return {
			is: null,
			sumMessage: 0,
			baoxiuMessage: 0,
			jiazhengMessage: 0,
			timer: ""
		}
	},
	components: {
		navcon,
		leftnav,
		left
	},
	methods: {
		getBaoxiu() {
			this.$http.get("/api/screen/getPendingCount").then(res => {
				if (res.data.code == 0) {
					this.baoxiuMessage = res.data.data.num;
				}
			}).catch(err => {
				console.log(err)
			})
		},
		show(val) {
			this.is = val;
		},
		// 消息的条数
		getSum() {
			this.$http.get("/api/message/getMessage").then(res => {
				if (res.data.code == 0) {
					this.sumMessage = res.data.data.num;
				}
			}).catch(err => {
				console.log(err)
			})
		},
	},
	beforeCreate() {
		if (this.$route.path != "/") {
			sessionStorage.token = localStorage.token
			sessionStorage.createId = localStorage.createId
			sessionStorage.roleId = localStorage.roleId
			sessionStorage.name = localStorage.name
		}
	},
	mounted() {
		// setInterval(() => {
		// 	this.$cookies.set("JSESSIONID", localStorage.cook)
		// 	console.log(localStorage.cook);
		// 	console.log(Math.random());
		// }, 0)

		this.timer = setInterval(() => {
			this.getSum();
			if (localStorage.roleId == "12") {
				this.getBaoxiu();
			}
		}, 30000)

		if (!localStorage.access_token) {
			console.log('index跳转到登录界面');
			this.$router.push('/login')
		} else {
			this.getSum();
		}

	},
	beforeDestroy() {
		clearInterval(this.timer);
		this.timer = null;
	}
};
</script>
<style scoped="scoped">
.main-con {
	position: relative;
}

.el-main {
	padding: 0;
	overflow-y: auto;
	height: calc(100vh - 65px);
	background-color: #fff;
}

.index {
	position: relative;
	top: 0;
	left: 0;
}

.left {
	width: 200px;
	height: 100vh;
	position: absolute;
	left: -200px;
	top: 0;
	z-index: 2;
	background-color: #000000;
	color: #fff;
}

.right {
	width: 100vw;
	position: relative;
}

div:focus {
	outline: none;
}

.el-aside {
	height: calc(100vh - 65px);
	background: #fff;
	overflow-y: auto;
	scrollbar-width: none;
	border-right: 1px solid #E4EAED;
}

.el-aside::-webkit-scrollbar {
	display: none;
	/* Chrome Safari */
}

.el-header {
	padding: 0;
	z-index: 999;
}

.show {
	/* animation: 0.3s show forwards linear; */
	/* transition: all 0.3s; */
	/* left: 200px; */
	transform: translateX(200px);
	transition: transform ease .4s, transform ease .4s, -webkit-transform ease .4s, -webkit-transform ease .4s;
}

.hidden {
	/* animation: 0.3s hidden forwards linear; */
	/* transition: all 0.3s; */
	/* left: 0px; */
	transform: translateX(0px);
	transition: transform ease .4s, transform ease .4s, -webkit-transform ease .4s, -webkit-transform ease .4s;
}

@keyframes show {
	from {
		/* left: 0; */
		transform: translateX(0px);
	}

	to {
		/* left: 200px; */
		transform: translateX(200px);
	}
}

@keyframes hidden {
	from {
		/* left: 200px; */
		transform: translateX(200px);
	}

	to {
		/* left: 0; */
		transform: translateX(0px);
	}
}
</style>
